import React, { useState } from "react";
import { doc, deleteDoc } from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import "../../Css/Dashcrud.css";

export default function FormDeletProduto() {
  const [categoria, setCategoria] = useState("");
  const [subcategoria, setSubcategoria] = useState("");
  const [tipo, setTipo] = useState("");
  const [id, setId] = useState("");

  const deletar = async () => {
    if (!categoria || !subcategoria || !tipo || !id) {
      alert("Preencha todos os campos");
      return;
    }

    await deleteDoc(
      doc(db, `Db/${categoria}/${subcategoria}/${tipo}/${id}`)
    );

    alert("🗑️ Produto apagado com sucesso");
  };

  return (
    <div className="container">
      <h1>Apagar Produto</h1>

      <div className="card danger">
        <input placeholder="Categoria" onChange={e => setCategoria(e.target.value)} />
        <input placeholder="Subcategoria" onChange={e => setSubcategoria(e.target.value)} />
        <input placeholder="Tipo" onChange={e => setTipo(e.target.value)} />
        <input placeholder="ID do Produto" onChange={e => setId(e.target.value)} />

        <button className="danger-btn" onClick={deletar}>
          Apagar
        </button>
      </div>
    </div>
  );
}
